import type { SurveyAnswerRecord } from '@coorum-research/shared-common/types/answer.type'
import type { Question } from 'survey-core'
import type { ISurveyCreator } from 'survey-react-ui'
import { SurveyQuestionAnswerBoolean } from './survey-answers/SurveyQuestionAnswerBoolean'
import { SurveyQuestionAnswerCheckbox } from './survey-answers/SurveyQuestionAnswerCheckbox'
import { SurveyQuestionAnswerDropdown } from './survey-answers/SurveyQuestionAnswerDropdown'
import { SurveyQuestionAnswerFile } from './survey-answers/SurveyQuestionAnswerFile'
import { SurveyQuestionAnswerImagepicker } from './survey-answers/SurveyQuestionAnswerImagepicker'
import { SurveyQuestionAnswerPanel } from './survey-answers/SurveyQuestionAnswerPanel'
import { SurveyQuestionAnswerRadiogroup } from './survey-answers/SurveyQuestionAnswerRadiogroup'
import { SurveyQuestionAnswerRanking } from './survey-answers/SurveyQuestionAnswerRanking'
import { SurveyQuestionAnswerRating } from './survey-answers/SurveyQuestionAnswerRating'

export function SurveyAnswerListItem({ creator, question, answerData }: {
  creator: ISurveyCreator
  question: Question
  answerData: SurveyAnswerRecord
}) {
  const questionType = question.getType()

  // panel質問の場合は値をチェックしない（panel内の個別質問に値がある）
  if (questionType !== 'panel' && (question.value === undefined || question.value === null || question.value === '')) {
    return <span className="text-gray-400">未回答</span>
  }
  // 個別に表示を変えたい場合はここに追加
  switch (questionType) {
  case 'text':
    return question.value.toString()
  case 'comment':
    return (
      <div className="whitespace-pre-wrap">
        {`${question.value.toString()}`}
      </div>
    )
  case 'radiogroup':
    return (
      <SurveyQuestionAnswerRadiogroup
        question={question}
      />
    )
  case 'checkbox':
    return (
      <SurveyQuestionAnswerCheckbox
        question={question}
      />
    )
  case 'rating':
    return (
      <SurveyQuestionAnswerRating
        question={question}
      />
    )
  case 'boolean':
    return (
      <SurveyQuestionAnswerBoolean
        question={question}
      />
    )
  case 'file':
    return (
      <SurveyQuestionAnswerFile
        creator={creator}
        question={question}
      />
    )
  case 'imagepicker':
    return (
      <SurveyQuestionAnswerImagepicker
        question={question}
      />
    )
  case 'ranking':
    return (
      <SurveyQuestionAnswerRanking
        question={question}
      />
    )
  case 'dropdown':
    return (
      <SurveyQuestionAnswerDropdown
        question={question}
      />
    )
  case 'panel':
    return (
      <SurveyQuestionAnswerPanel
        creator={creator}
        question={question}
        answerData={answerData}
      />
    )
  default:
    return question.value.toString()
  }
}
